import './ApplyLink.scss';

import React, { PureComponent } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Button from 'components/clickables/Button';
import CSRFInput from 'components/forms/CSRFInput';
import Text from 'components/Text';

import cxHelpers from 'util/className';

@cxHelpers('ApplyLink')
export default class ApplyLink extends PureComponent {
  static propTypes = {
    applyLink: PropTypes.instanceOf(Map),
    onToggleApplicationForm: PropTypes.func,
    showApplicationForm: PropTypes.bool,
  };

  renderApplyLink = () => {
    const { applyLink, onToggleApplicationForm } = this.props;
    const alreadyApplied = !applyLink;
    const linksToApplicationForm =
      applyLink && applyLink.get('method') === 'get';
    const oneClickApply = applyLink && applyLink.get('method') === 'post';

    if (alreadyApplied) {
      return (
        <Button className={this.cxEl('already-applied-button')} disabled>
          <Text i18n="hiring.job_request.already_applied" />
        </Button>
      );
    } else if (linksToApplicationForm) {
      const i18nSuffix = this.props.showApplicationForm ? 'cancel' : 'apply';

      return (
        <Button
          className={this.cxEl('link-button')}
          href={!onToggleApplicationForm ? applyLink.get('url') : null}
          onClick={this.handleClick}
        >
          <Text i18n={`actions.${i18nSuffix}`} />
        </Button>
      );
    } else if (oneClickApply) {
      return (
        <form action={applyLink.get('url')} method="post">
          <CSRFInput />
          <Button className={this.cxEl('form-button')} type="submit">
            <Text i18n="actions.apply" />
          </Button>
        </form>
      );
    }
  };

  handleClick = () =>
    this.props.onToggleApplicationForm && this.props.onToggleApplicationForm();

  render() {
    return <div className={this.cx()}>{this.renderApplyLink()}</div>;
  }
}
